module.exports = __webpack_public_path__ + "static/media/cats.3b5e73f6.jpeg";